<template>
  <div id="selectpage" style="background:#eee">
    <b-container class="container">
      <div class="cardOriGroup">
        <div>
          <input id="ori_h" type="radio" v-model="cardOri" name="cardOriRd" value="0"></input>
          <label for="ori_h">横版</label>
          <span style="padding:0 20px;">/</span>
          <input id="ori_v" type="radio" v-model="cardOri" name="cardOriRd" value="1"></input>
          <label for="ori_v">竖版</label>
        </div>
      </div>

      <div>
        <b-row style="margin-right: -35px;margin-left: -35px;">
          <b-col :cols="cardOri==0?'6':'4'" :class="cardOri==0? 'mx-auto text-center uploadGroup':'mx-auto text-center uploadGroupV'" @click="selectCardface()" style="padding:25px 0px;">
            <b-img class="mt-2" src="static/qlbank/img_upload.png" style="width:55px;height:51px;"></b-img>
            <div class="mt-2" style="font-weight: normal;font-size:12px;"><b>点此上传图片</b></div>
          </b-col>
        </b-row>
      </div>

      <div class="shangchuan" style="margin-top: 200px;background:#fff;">
        <div style="padding:20px 15px">
          <h6 style="font-size:20px;">上传须知</h6>
          <div style="padding:10px 15px;font-size:14px;color:#777777">
            <div>1.图片最小分辨率为{{pxLimit}}像素，最大为10MB</div>
            <div>2.涉黄、涉暴、涉政等违规图片将无法审核通过</div>
          </div>
        </div>
      </div>
      <div v-show="false">
        <form ref="imgUploadForm">
          <input ref="uploadInput" type="file" accept="image/*" @change.prevent.stop="upload">
        </form>
      </div>

      <b-modal ok-only ref="model_error" title="提示" @ok="handleOk" ok-title="确定">
        <p class="my-4">{{errorMsg}}</p>
      </b-modal>
    </b-container>

  </div>
</template>

<script>
import wx from "weixin-js-sdk";
import axios from "axios";
var config = require("../../common/config.js");
export default {
  name: "SelectCardface_qs",
  data() {
    return {
      bankSerialNumber: "", //序列号、唯一标识
      bankCode: "", //银行编号
      messageData: "", //手机号
      selectParam: "",
      cardOri: 0,
      pxLimit: "1075 * 686",
      imgWlimit: 1075,
      imgHlimit: 686,
      imgSizeLimit: 10 * 1024 * 1024,
      errorMsg: "",
    };
  },
  watch: {
    cardOri: function (newval, oldval) {
      console.log("当前版面方向：" + newval, "之前版面方向：" + oldval);
      if (newval == 0) {
        this.imgWlimit = 1075;
        this.imgHlimit = 686;
        this.pxLimit = "1075 * 686";
      } else if (newval == 1) {
        this.imgWlimit = 686;
        this.imgHlimit = 1075;
        this.pxLimit = "686 * 1075";
      }
      // console.log('imgWlimit' + this.imgWlimit)
      // console.log('imgHlimit' + this.imgHlimit)
    },
  },
  mounted: function () {
    // this.DecodeData();
    // this.wxJsSdk()
    // this.bankSerialNumber = this.$route.params.bankSerialNumber;
    // console.log("bankSerialNumber:" + this.bankSerialNumber);
  },
  methods: {
    DecodeData() {
      axios
        .get(config.config_qs.getDecodeData, {
          params: {
            applyDetail:
              "MmaAg4ej8b04LSh8ijU%2F5lCd2DBlauWNnRSNsTLDFzylt%2BOD%2Bty%2B%2BfhY4CFoT%2Fweiz9tED2SN7kz%0D%0AICU5PUeVUIWcEur2rQUbQ0%2BjVKRLlXRNixwS%2BQD5G0uQLGkZejvSVK1yoEfRECvmaciTfKWsxH53%0D%0AYoUOaohL2hhMezg7VluZUFw9Xsp2A8QVXkuO%2B5KBQYZUJTd%2FRdVKifGYj%2F0orEqlrhpWSM%2FLfui5%0D%0ANQG7V8dHbPgW1Iiv83yarBeacFYVP1oYWb5%2Fa2TKCs1fUILeMwmxqt2kTEbn0FFRNSy%2FTeLWGgnz%0D%0AUUfpDKhBhhuYX3p8mnZHh%2BS8mHY5nDjRjd93sA%3D%3D%0D%0A",
          },
        })
        .then((res) => {
          console.log("res", res);
        });
    },
    upload: function (event) {
      var that = this;
      console.log(event);
      let file = event.target.files[0];
      let fileSize = file.size;
      console.log(file);
      let url = null;
      if (window.createObjectURL != undefined) {
        // basic
        url = window.createObjectURL(file);
      } else if (window.webkitURL != undefined) {
        // webkit or chrome
        url = window.webkitURL.createObjectURL(file);
      } else if (window.URL != undefined) {
        // mozilla(firefox)
        url = window.URL.createObjectURL(file);
      }
      console.log(url);
      if (fileSize > this.imgSizeLimit) {
        that.errorMsg = "图片大小不能超过10MB";
        that.showErrorMsg();
        that.resetUpload();
      } else {
        let image = new Image();
        let w, h;
        image.src = url;
        image.onload = function () {
          w = image.width; // 图片宽度
          h = image.height; // 图片高度
          image.onload = null; // 避免重复加载

          // console.log('图片宽高:' + w + '*' + h)
          // console.log('图片大小:' + (fileSize / 1024) + 'KB')
          if (w >= that.imgWlimit && h >= that.imgHlimit) {
            that.toEditCardface(url, file);
          } else {
            that.errorMsg = "图片像素不符合要求，图片的像素：" + w + "*" + h;
            that.showErrorMsg();
            that.resetUpload();
          }
        };
      }
    },
    toEditCardface: function (imgPath, file) {
      var selectParam = JSON.stringify(this.selectParam);
      this.$router.push({
        name: "EditCardface_qs",
        params: {
          imagePath: imgPath,
          bankSerialNumber: this.bankSerialNumber,
          bankCode: this.bankCode,
          messageData: this.messageData,
          selectParam: selectParam,
          cardOri: this.cardOri,
          file: file,
        },
      });
    },

    resetUpload: function () {
      var form = this.$refs.imgUploadForm;
      console.log(form);
      form.reset();
    },
    handleOk: function (bvModalEvt) {},
    showErrorMsg: function () {
      this.$refs["model_error"].show();
    },
    hideErrorMsg: function () {
      this.$refs["model_error"].hide();
    },
    selectCardface: function () {
      this.resetUpload();
      this.$refs.uploadInput.click();
      // var that = this;
      // wx.chooseImage({
      //   count: 1, // 默认9
      //   sizeType: ['original', 'compressed'], // 可以指定是原图还是压缩图，默认二者都有
      //   sourceType: ['album', 'camera'], // 可以指定来源是相册还是相机，默认二者都有
      //   success: function(res) {
      //     console.log(res);
      //     var localIds = res.localIds; // 返回选定照片的本地ID列表，localId可以作为img标签的src属性显示图片
      //     var faceImgPath = localIds[0];
      //     console.log('imgPath:' + faceImgPath);
      //     that.checkImg(faceImgPath);
      //   },
      // });
    },
  },

  activated: function () {
    var applyData = this.$route.params; //获取
    console.log("applyData", applyData);
    if (JSON.stringify(applyData) != "{}") {
      sessionStorage.setItem("applyInfo", JSON.stringify(applyData));
    }

    this.bankSerialNumber = applyData.flowNo; //唯一标识、流水号、银行唯一序列号
    this.bankCode = applyData.merchNo; //齐商银行固定编码
    this.messageData = applyData;

    var selectParam = applyData.selectParam; // this.$route.params.selectParam;
    if (selectParam !== undefined) {
      this.selectParam = JSON.parse(selectParam);
    }
    if (JSON.stringify(applyData) == "{}") {
      //由用户手机返回功能
      var orderInSession = sessionStorage.getItem("orderInfo");
      var applySession = sessionStorage.getItem("applyInfo");
      if (orderInSession && orderInSession) {
        //从支付返回
        let orderInfoObj = JSON.parse(orderInSession);
        console.log(`支付返回`, orderInfoObj);
        this.bankSerialNumber = orderInfoObj.messageData.flowNo; //唯一标识、流水号、银行唯一序列号
        this.bankCode = orderInfoObj.messageData.merchNo; //齐商银行固定编码
        this.messageData = orderInfoObj.messageData.mobileNo; //用户手机号
        this.selectParam = {
          isModify: 1, //更改图片
          orderNo: orderInfoObj.orderNo, //编号
          isPayed: false, //申请流程  true是查询流程过来的
        };
      } else {
        //从图片调整返回
        let oapplyInfoObj = JSON.parse(applySession);
        console.log(`图片调整返回`, oapplyInfoObj);
        this.bankSerialNumber = oapplyInfoObj.flowNo; //唯一标识、流水号、银行唯一序列号
        this.bankCode = oapplyInfoObj.merchNo; //齐商银行固定编码
        this.messageData = oapplyInfoObj;
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    console.log("SelectCardface_qs beforeRouteLeave");
    console.log("to", to);
    console.log("from", from);
    if (to.name == "Home") {
      this.$router.go(0);
    } else if (to.name != "EditCardface_qs") {
      // 重新上传卡面
      let reupload = this.$store.state.qs.reuploadCount > 0;
      console.log("reupload->" + reupload)
      let count = this.$store.state.qs.reuploadCount;
      console.log("count>" + count)
      if (reupload) {
        this.$store.commit("qs/decreReuploadImg");
      }
      this.selectParam = "";
    }
    next();
  },
};
</script>

<style scoped>
#selectpage {
  left: 0;
  top: 0;
  position: absolute;
  width: 100%;
  height: 100%;
}
.container {
  padding: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: relative;
}
.container .shangchuan {
  position: absolute;
  bottom: 0px;
  left: 0px;
  right: 0px;
  /* top: 0; */
}

.uploadGroup {
  border: lightgray solid 1px;
  border-radius: 4px;
  border-style: dashed;
}
.uploadGroupV {
  border: lightgray solid 1px;
  border-radius: 4px;
  border-style: dashed;
  height: 180px;
}

.cardOriGroup {
  margin-bottom: 20px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  text-align: center;
  align-items: flex-end;
  height: 64px;
}

.cardOriGroup input {
  display: none;
}

.cardOriGroup label {
  color: gray;
  line-height: 28px;
  min-width: 20vw;
  min-height: 28px;
  text-align: center;
  border-radius: 4px;
  margin: 8px;
}

.cardOriGroup input:checked + label {
  background-size: 21px 21px;
  font-weight: bold;
  color: black;
  margin: 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/qishangbank/SelectCardface_qs.vue